// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'

const MonthYearContainer = styled.div`

  display: inline-block;

  .month-name {
    margin: 0;
    text-transform: capitalize;
  }

`

export default function MonthYear({ date, fullName, ...props }) {

  const locale = 'fr-FR'

  const monthShort = { month: 'short' }
  const monthLong = { month: 'long' }

  return (
    <MonthYearContainer { ...props }>
      { !fullName ? <p className="month-name">{ date?.toLocaleString(locale, monthShort) } { date.getFullYear() }</p> : '' }
      { fullName ? <p className="month-name">{ date?.toLocaleString(locale, monthLong) } { date.getFullYear() }</p> : '' }
    </MonthYearContainer>
  )

}
